import React, {useState}				from 'react';

import {TextareaProps}					from './interface';

import './Textarea.css';

const defaultProps: TextareaProps = {
	title:     	   '',
	placeholder:   '',
	value:     	   '',
	onChange:      () => null
};

function	Textarea(props: TextareaProps = defaultProps) {
	const [change, set_change] = useState(false);

	function onChange(val: React.ChangeEvent<HTMLTextAreaElement>) {
		if (!change)
			set_change(true);
		if (props.onChange)
			props.onChange(val.target.value);
	}

	const style: React.CSSProperties = {...props.style};
	let	error = props.error;

	if (props.required && !props.value && change)
		error = true;

	style.resize = props?.resize ? 'vertical' : 'none';

	return (
		<div className={`textareaMainContainer ${props.flex && 'flex'}`}>
			{props.title &&
				<span className={'textareaTitle'} style={props.styleTitle}>
					{props.title}{props.required && '*'}
				</span>
			}

			<textarea
				style={style}
				value={props.value}
				onChange={onChange}
				readOnly={props.readOnly || undefined}
				placeholder={props.placeholder || undefined}
				className={`textareaContainer ${error && 'error'} ${props.readOnly && 'readOnly'}`}
			/>

			{props.maxChar &&
				<span
					className={'textareaMaxChar'}
					data-error={props.value.toString().length > props.maxChar}
				>
					{`${props.value.toString().length}/${props.maxChar}`}
				</span>
			}

			{(props.error && typeof(props.error) === 'string') &&
				<span className={'textareaErrorText'}>
					{props.error}
				</span>
			}
		</div>
	);
}

export default Textarea;